export default __webpack_public_path__ + "assets/images/b2b921f5d9355d20e1e708a40aeb44e3.png";